const isInCart = function (cart, purchasableId, options) {
  // Iterator to deal with the cart lineitems JSON
  let forEachItem = (cb) => {
    for (var prop in cart.lineItems) {
      cb(cart.lineItems[prop]);
    }
  };

  var isInCart = false;

  forEachItem((item) => {
    if (item.purchasableId == purchasableId) {
      if (options) {
        if (JSON.stringify(item.options) == JSON.stringify(options)) {
          isInCart = item;
        }
      } else {
        // NOW IN CART:
        // SUCCESS
        isInCart = item;
      }
    }
  });

  return isInCart;
};

export default isInCart;
